(function () {
  const root = document.getElementById('smart-delivery');
  if (!root) return;

  const dataEl = document.getElementById('smart-delivery-data');
  if (!dataEl) return;

  const config = JSON.parse(dataEl.textContent);
  const showExactDate = root.dataset.showExactDate === 'true';

  const statusText = root.querySelector('[data-sd-status-text]');
  const prefixEl = root.querySelector('[data-sd-prefix]');
  const messageEl = root.querySelector('[data-sd-message]');

  const CACHE_KEY = 'sd_geo_governorate';
  const CACHE_TTL_MS = 1000 * 60 * 60 * 24 * 7;
  const isArabic = (config.locale || '').startsWith('ar');

  const monthsEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthsAr = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

  function getOrdinal(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  }

  function formatShort(date) {
    const day = date.getDate();

    if (isArabic) {
      return `${day} ${monthsAr[date.getMonth()]}`;
    }

    return `${monthsEn[date.getMonth()]} ${day}${getOrdinal(day)}`;
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function normalizeText(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[’']/g, "'");
  }

  function normalizeGovernorateName(value) {
    const v = normalizeText(value);

    const aliases = {
      'cairo': 'cairo',
      'al qahirah': 'cairo',
      'al qāhirah': 'cairo',
      'القاهرة': 'cairo',
      'new cairo': 'cairo',
      'nasr city': 'cairo',
      'heliopolis': 'cairo',
      'maadi': 'cairo',
      'zamalek': 'cairo',
      'mokattam': 'cairo',
      'tagamoa': 'cairo',
      'tagamoa el khames': 'cairo',
      'fifth settlement': 'cairo',

      'giza': 'giza',
      'al jizah': 'giza',
      'al jīzah': 'giza',
      'الجيزة': 'giza',
      'dokki': 'giza',
      'mohandessin': 'giza',
      '6th of october': 'giza',
      'october': 'giza',
      'sheikh zayed': 'giza',
      'haram': 'giza',
      'faisal': 'giza',

      'alexandria': 'alexandria',
      'al iskandariyah': 'alexandria',
      'al iskandarīyah': 'alexandria',
      'الأسكندرية': 'alexandria',
      'الاسكندرية': 'alexandria',
      'alex': 'alexandria',
      'sidi gaber': 'alexandria',
      'smouha': 'alexandria',
      'miami': 'alexandria',
      'montaza': 'alexandria',

      'dakahlia': 'dakahlia',
      'mansoura': 'dakahlia',
      'mansura': 'dakahlia',
      'المنصورة': 'dakahlia',

      'sharqia': 'sharqia',
      'zagazig': 'sharqia',

      'qalyubia': 'qalyubia',
      'qalyoubia': 'qalyubia',
      'banha': 'qalyubia',

      'gharbia': 'gharbia',
      'tanta': 'gharbia',

      'monufia': 'monufia',
      'menofia': 'monufia',
      'shibin el kom': 'monufia',

      'beheira': 'beheira',
      'damanhur': 'beheira',

      'kafr el sheikh': 'kafr el sheikh',
      'kafr el-sheikh': 'kafr el sheikh',

      'damietta': 'damietta',
      'port said': 'port said',
      'ismailia': 'ismailia',
      'suez': 'suez',
      'fayoum': 'fayoum',
      'faiyum': 'fayoum',
      'beni suef': 'beni suef',
      'minya': 'minya',
      'assiut': 'assiut',
      'asyut': 'assiut',
      'sohag': 'sohag',
      'qena': 'qena',
      'luxor': 'luxor',
      'aswan': 'aswan',
      'red sea': 'red sea',
      'new valley': 'new valley',
      'matrouh': 'matrouh',
      'north sinai': 'north sinai',
      'south sinai': 'south sinai'
    };

    return aliases[v] || v;
  }

  const configuredFastGovernorates = (config.fastGovernorates || []).map((g) => normalizeGovernorateName(g));
  const fastSet = new Set(configuredFastGovernorates);

  function render(governorate) {
    const normalizedGovernorate = normalizeGovernorateName(governorate);
    const isFast = normalizedGovernorate && fastSet.has(normalizedGovernorate);

    statusText.textContent = isArabic ? 'جاهز للشحن' : 'Ready to ship';

    if (isFast) {
      const now = new Date();
      const start = addDays(now, 1);
      const end = addDays(now, 2);

      if (showExactDate) {
        prefixEl.textContent = isArabic ? 'يصل خلال ' : ' arrives ';
        messageEl.textContent = `${formatShort(start)}–${formatShort(end)}`;
      } else {
        prefixEl.textContent = isArabic ? 'خلال ' : ' within ';
        messageEl.textContent = isArabic ? '١–٢ يوم' : '1–2 days';
      }
    } else {
      const now = new Date();
      const start = addDays(now, 2);
      const end = addDays(now, 5);
      
      if (showExactDate) {
        prefixEl.textContent = isArabic ? 'يصل خلال ' : ' arrives ';
        messageEl.textContent = `${formatShort(start)}–${formatShort(end)}`;
      } else {
        prefixEl.textContent = isArabic ? 'خلال ' : ' within ';
        messageEl.textContent = isArabic ? '٢–٥ أيام عمل' : '2–5 business days';
      }
    }
  }

  function getCached() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.timestamp > CACHE_TTL_MS) return null;

      return parsed.governorate;
    } catch (e) {
      return null;
    }
  }

  function setCached(governorate) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          governorate: governorate || '',
          timestamp: Date.now()
        })
      );
    } catch (e) {}
  }

  function extractGovernorate(data) {
    if (!data) return null;

    const candidates = [
      data.region,
      data.region_name,
      data.city
    ];

    for (const candidate of candidates) {
      const normalized = normalizeGovernorateName(candidate);
      if (normalized) return normalized;
    }

    return null;
  }

  function detectGovernorate() {
    const cached = getCached();

    if (cached !== null) {
      render(cached || null);
      return;
    }

    fetch('https://ipapi.co/json/', {
      signal: AbortSignal.timeout(3000)
    })
      .then((res) => {
        if (!res.ok) throw new Error('geoip failed');
        return res.json();
      })
      .then((data) => {
        let governorate = null;

        if (data && data.country_code === 'EG') {
          governorate = extractGovernorate(data);
        }

        setCached(governorate);
        render(governorate);
      })
      .catch(() => {
        setCached('');
        render(null);
      });
  }

  detectGovernorate();
})();